// Same id as in table afm_page_type
enum pageTypes {
    FinanceAllTransactions = 600059,
    FinanceCurrentTransactions = 600058,
    FinanceRemittances = 600060,
}

export const performancePageMapRoute: {[path: string]: number} = {
    '/finance/currenttransactions': pageTypes.FinanceCurrentTransactions,
    '/finance/alltransactions': pageTypes.FinanceAllTransactions,
    '/finance/remittances': pageTypes.FinanceRemittances,
}